import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=c954729e&scoped=true&lang=pug"
import script from "./Resumo.vue?vue&type=script&lang=js"
export * from "./Resumo.vue?vue&type=script&lang=js"
import style0 from "./Resumo.vue?vue&type=style&index=0&id=c954729e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c954729e",
  null
  
)

export default component.exports